import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

const MediumBell = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M14.9001 11.25L13.5901 9.55999V5.86999C13.5901 2.81999 11.1001 0.329988 8.04006 0.299988C8.03006 0.299988 8.01006 0.299988 8.00006 0.299988C7.99006 0.299988 7.97006 0.299988 7.96006 0.299988C4.89006 0.329988 2.41006 2.81999 2.41006 5.85999V9.54999L1.10006 11.25C0.770057 11.68 0.710057 12.26 0.950057 12.75C1.19006 13.24 1.68006 13.55 2.23006 13.55H13.7601C14.3201 13.55 14.8101 13.24 15.0501 12.74C15.2901 12.25 15.2301 11.67 14.8901 11.25H14.9001Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M7.98998 15.7C8.95998 15.7 9.78998 15.17 10.24 14.39H5.72998C6.17998 15.17 7.01998 15.7 7.97998 15.7H7.98998Z",
                    fill: "currentColor"
                })
            ]
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M7.4 12.85H13.76C14.37 12.85 14.72 12.16 14.34 11.68L12.89 9.8V5.87C12.89 3.2 10.68 1 7.98 1H8.02C5.32 1 3.11 3.19 3.11 5.87V9.8L1.66 11.68C1.29 12.16 1.64 12.85 2.24 12.85H8.6",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M7.4 12.85H6.11C6.09 12.93 6.09 13.02 6.09 13.11C6.09 14.16 6.95 15 8 15C9.05 15 9.91 14.15 9.91 13.11C9.91 13.02 9.89 12.94 9.89 12.85H7.42H7.4Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};

export { MediumBell as default };
